import gsap from "gsap";
import Observer from "gsap/Observer";
import { Component } from "../../helpers/compiler";

@Component({ className: 'js-magic-scroll-toggle-visibility' })
export class MagicScrollToggleVisibilityComponent {
    constructor(private element: HTMLElement) {
        gsap.registerPlugin(Observer);
        this.setTopStyle();

        Observer.create({
            target: window,
            type: 'scroll',
            tolerance: 50,
            onUp: () => this.element.classList.remove('is-hidden'),
            onDown: () => {
                if (window.scrollY > 100) {
                    this.element.classList.remove('is-top')
                    this.element.classList.add('is-hidden')
                }
            },
            onChange: () => setTimeout(this.setTopStyle, 100)
        });
    }

    private setTopStyle() {
        if (window.scrollY < 100) {
            this.element.classList.add('is-top')
        }
    }
}
